import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import LoaderHavePopup from 'src/component-project/loader_have_popup';
import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';
import ComboBox from 'src/components/Input/ComboBox';
import TextInput from 'src/components/Input/TextInput';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../../../components/Button.js/SaveButton';
import NumberInput from '../../../components/Input/NumberInput';
import Loader from '../../../components/loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const AdminGetDevice = ({ visible = false, callBackFunct, setVisible, data, idPermission }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [flagProcess, setFlagProcess] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const isHandledRef = useRef(false);
    const flagRef = useRef(false);
    const user = glb_sv.userInfo;
    const isAdmin = (user?.group_user === '1' || user?.group_user === '2') && data?.status === '5';
    const cabinetAtAccount = glb_sv.getLocalStorageCabinet('cabinet');
    useEffect(() => {
        try {
            setIsOpen(false);
            setDataDrawer([]);
            setDataCell([]);
            setQuantity(data?.qty_change_request || data?.qty);
            if (data?.cabinet_id && visible && data?.device_cd) {
                isHandledRef.current = false;
                getDataDrawer(data?.cabinet_id);
            }
        } catch (e) {}
    }, [visible]);

    useEffect(() => {
        try {
            if (selectDrawer !== 0 && visible) {
                setSelectedCell(null);
                getAllCell(data?.cabinet_id, selectDrawer);
            }

            if (selectDrawer === 0 && visible) {
                setDataCell([]);
                setSelectedCell(null);
            }
        } catch (e) {}
    }, [selectDrawer, data?.id, visible]);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);

    const timeOutFunctCabinet = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
    };
    const getDataDrawerResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1].filter((ele) => ele.block_status === '1');
            const drawerDataSuggest = message.proc_data?.suggest_drawer;
            drawerData.map((ele) => {
                setDataDrawer((prev) => {
                    if (prev.some((item) => item.value === ele.id)) return prev;

                    return [
                        ...prev,
                        {
                            label: ele.drawer_nm,
                            value: ele.id,
                            lc: ele.drawer_lc,
                        },
                    ];
                });
            });
            setSelectDrawer(data?.drawer_id);
        }
    };

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 15000);
        },
        [data?.cabinet_id, visible]
    );

    const adminGet = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.admin_get_in_cell, InVal, adminGetResult, true, timeOutFunct, 15000);
        },
        [data?.id]
    );

    const adminGetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
        }
    };

    const getAllCell = useCallback(
        (id_capinet, id_drawer) => {
            const InVal = [idPermission, id_capinet, id_drawer];
            sendRequest(serviceList.getAllbox, InVal, getDataCellResult, true, timeOutFunct, 15000);
        },
        [data?.cabinet_id, selectDrawer, data?.cabinet_id, data?.id]
    );

    const getDataCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCell([...message.proc_data.rows[0].o_1]);
            setSelectedCell([...message.proc_data.rows[0].o_1].find((ele) => ele.id === data.cell_id));
            console.log([...message.proc_data.rows[0].o_1].find((ele) => ele.id === data.cell_id));
        }
    };
    // region send request grinding device
    const handleClick = useCallback(() => {
        if (isHandledRef.current) return;
        setFlagProcess(true);
        isHandledRef.current = true;
        const InVal = [data.id];
        sendRequest(serviceList.adminGetCheckDepreciation, InVal, actionResult, true, timeOutFunct, 600000);
        // actionResult("aaaa", {proc_status: 1, proc_message: "fininse"})
    }, [data]);

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            closeCell();
        }
    };
    // region open cell
    const openCell = (data) => {
        console.log(data);
        if (data?.cabinet_cd !== cabinetAtAccount?.cabinet_cd) {
            toast.error(t('select_right_cabinet'));
            return;
        }
        setFlagProcess(true);

        let service = serviceList.openCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === (selectDrawer || data?.drawer_id))?.lc;
        let inpuVal = [
            cabinetAtAccount?.cabinet_cd || data.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];

        if (cabinetAtAccount?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                cabinetAtAccount?.cabinet_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [
                cabinetAtAccount?.cabinet_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.column,
                selectedCell.column,
            ];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 30000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            toast.error('Error: ' + message['proc_message']);
        } else {
            // isGivedevice ? handleActionGiveDevice() : handleActionDevice();
            setFlagProcess(false);
            setIsOpen(true);
            // if (data?.status === '5') adminGet(data?.id);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        clearIntervalCheckStatusCell();
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === ele.id)?.lc;
        let inpuVal = [
            cabinetAtAccount?.cabinet_cd,
            drawer_lc_select,
            selectedCell?.cell_lc.row,
            selectedCell?.cell_lc.column,
        ];
        if (cabinetAtAccount?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [
                cabinetAtAccount?.cabinet_cd,
                drawer_lc_select,
                selectedCell?.cell_lc.row,
                selectedCell?.cell_lc.column,
            ];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [cabinetAtAccount?.cabinet_cd, drawer_lc_select, selectedCell?.cell_lc.row, selectedCell?.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 30000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            setFlagProcess(false);
            callBackFunct && callBackFunct();
            isHandledRef.current = false;
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;

        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            10000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            clearIntervalCheckStatusCell();
            if (!data?.cell_id && !data?.cabinet_id && !data?.drawer_id) {
                if (!isHandledRef.current || !flagProcess) {
                    handleClick();
                }
            } else {
                closeCell();
            }
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        setFlagProcess(false);
    };

    const timeOutFunct = (reqInfo) => {
        setFlagProcess(false);
        setIsOpen(false);
        toast.error(t('error.time_out'));
    };

    const handleQuantityChange = (val) => {
        if (val <= data.qty) {
            setQuantity(val);
        } else {
            setQuantity(data.qty);
        }
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('take_device_to_depreciation')} <br /> {t('name_device')}: {data?.device_cd}_{data?.device_nm}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess || isHandledRef.current} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput
                            label={t('amount')}
                            valueChange={quantity}
                            size="medium"
                            getValue={handleQuantityChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <TextInput
                            label={t('choose_cabinet')}
                            valueChange={cabinetAtAccount?.cabinet_nm}
                            disabled
                            size="medium"
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <ComboBox
                            label={t('choose_drawer')}
                            sizeCbb="medium"
                            displayLabel="label"
                            valueSelect={dataDrawer.find((ele) => ele.value === selectDrawer)}
                            valueEqual="value"
                            getValue={(e) => setSelectDrawer(e?.value || 0)}
                            selectOption={dataDrawer}
                            required
                            // disabled={isAdmin || data?.status === '7' || data?.status === '5'}
                            disabled={true}
                        />
                    </Grid>
                    {dataCell.length > 0 && cabinetAtAccount && data && (
                        <>
                            <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                                {t('select_device_the_cell_noti')}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    textAlign: 'center',
                                    display: 'block',
                                    fontStyle: 'italic',
                                    width: '100%',
                                    color: '#adb1b5',
                                }}
                            >
                                {t('cell_have_lock')}
                            </Typography>
                            <ChessBoardSelectCell
                                typeCabinet={data?.cabinet_type}
                                cell_id_request={data?.cell_id}
                                onSelect={(pos) => {
                                    // if (!isAdmin && data?.status !== '5' && data?.status !== '7') {
                                    //     setSelectedCell(pos);
                                    // }
                                }}
                                dataCell={dataCell}
                                selectedCell={selectedCell}
                            />
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                {!isOpen ? (
                    <ButtonAction
                        onClick={() => {
                            openCell(data);
                            // handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('open_cell_output')}
                    />
                ) : (
                    <ButtonAction
                        onClick={() => {
                            handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('confrim_success')}
                    />
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default AdminGetDevice;
